export const moduleActions = {
  CHANGE_ACTIVE_MODULE: 'module/CHANGE_ACTIVE_MODULE',
  CHANGE_ACTIVE_MENU_ITEM: 'module/CHANGE_ACTIVE_MENU_ITEM',
  TOGGLE_KEEP_ORIGIN: 'module/TOGGLE_KEEP_ORIGIN',
};
